import { render, staticRenderFns } from "./PastMeetings.vue?vue&type=template&id=5373b64a&scoped=true&"
import script from "./PastMeetings.vue?vue&type=script&lang=js&"
export * from "./PastMeetings.vue?vue&type=script&lang=js&"
import style0 from "./PastMeetings.vue?vue&type=style&index=0&id=5373b64a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5373b64a",
  null
  
)

export default component.exports